<template>
  <div class="editor-box">
    <el-form
      label-width="160px"
      label-position="right"
      label-suffix="："
      v-if="loaded"
    >
      <el-form-item label="类型">
        {{ schema.title }}
      </el-form-item>
      <el-form-item label="名称" required>
        <el-input v-if="isAdd" v-model="entryName" />
        <span v-else>{{ entryName }}</span>
      </el-form-item>
      <el-form-item v-if="!isAdd" label="完全限定名(DN)">
        {{ dn }}
      </el-form-item>
      <template v-for="attr in editableAttrs">
        <template v-if="schema.attrHandlers[attr.name]">
          <el-form-item
            v-for="prop in schema.attrHandlers[attr.name].props"
            :key="prop.name"
            :label="prop.title"
          >
            <el-select
              v-if="prop.type === 'select'"
              v-model="attrData[prop.name]"
              :disabled="attr.readonly"
            >
              <el-option
                :value="option.key"
                :key="option.key"
                v-for="option in prop.options"
                :label="option.value"
              ></el-option>
            </el-select>
            <el-input
              v-else-if="prop.type === 'password'"
              type="password"
              :readonly="attr.readonly"
              v-model="attrData[prop.name]"
            />
            <el-input
              v-else
              :readonly="attr.readonly"
              v-model="attrData[prop.name]"
            />
          </el-form-item>
        </template>
        <template v-else>
          <el-form-item
            :key="attr.name"
            :label="attr.title"
            :required="attr.required"
          >
            <el-input :readonly="attr.readonly" v-model="attrData[attr.name]" />
          </el-form-item>
        </template>
      </template>
      <el-form-item label="同步方式">
        <el-radio
          :label="true"
          :value="taskMap.type === SYNC_TYPE.Inherit"
          @click.native="taskMap.type = SYNC_TYPE.Inherit"
          >继承父级</el-radio
        >
        <el-radio
          :label="true"
          :value="taskMap.type.hasFlag(SYNC_TYPE.Sync)"
          @click.native="syncEnable"
          >独立设置</el-radio
        >
        <el-radio
          :label="true"
          :value="taskMap.type === SYNC_TYPE.None"
          @click.native="taskMap.type = SYNC_TYPE.None"
          >不同步</el-radio
        >
      </el-form-item>
      <template v-if="taskMap.type.hasFlag(SYNC_TYPE.Sync)">
        <el-form-item
          label="通讯组同步类型"
          v-if="schema.isGroup || schema.isContainer"
        >
          <el-radio
            :label="true"
            :value="
              taskMap.type.hasFlag(SYNC_TYPE.WithDomainGroup) &&
                !taskMap.type.hasFlag(SYNC_TYPE.WithOutDomainGroup)
            "
            @click.native="
              taskMap.type = taskMap.type.changeFlag(
                SYNC_TYPE.WithDomainGroup,
                SYNC_TYPE.WithOutDomainGroup
              )
            "
            >仅域内</el-radio
          >
          <el-radio
            :label="true"
            :value="
              taskMap.type.hasFlag(SYNC_TYPE.WithDomainGroup) &&
                taskMap.type.hasFlag(SYNC_TYPE.WithOutDomainGroup)
            "
            @click.native="
              taskMap.type = taskMap.type.addFlag(
                SYNC_TYPE.WithDomainGroup,
                SYNC_TYPE.WithOutDomainGroup
              )
            "
            >域内和域外</el-radio
          >
          <el-radio
            :label="true"
            :value="
              !taskMap.type.hasFlag(SYNC_TYPE.WithDomainGroup) &&
                !taskMap.type.hasFlag(SYNC_TYPE.WithOutDomainGroup)
            "
            @click.native="
              taskMap.type = taskMap.type.removeFlag(
                SYNC_TYPE.WithDomainGroup,
                SYNC_TYPE.WithOutDomainGroup
              )
            "
            >不同步</el-radio
          >
        </el-form-item>
        <el-form-item
          label="用户同步类型"
          v-if="schema.isUser || schema.isContainer"
        >
          <el-radio
            :label="true"
            :value="taskMap.type.hasFlag(SYNC_TYPE.ToUnit)"
            @click.native="
              taskMap.type = taskMap.type.changeFlag(
                SYNC_TYPE.ToUnit,
                SYNC_TYPE.ToPub
              )
            "
            >通讯录</el-radio
          >
          <el-radio
            :label="true"
            :value="taskMap.type.hasFlag(SYNC_TYPE.ToPub)"
            @click.native="
              taskMap.type = taskMap.type.changeFlag(
                SYNC_TYPE.ToPub,
                SYNC_TYPE.ToUnit
              )
            "
            >公共联系人</el-radio
          >
          <el-radio
            :label="true"
            :value="
              !taskMap.type.hasFlag(SYNC_TYPE.ToUnit) &&
                !taskMap.type.hasFlag(SYNC_TYPE.ToPub)
            "
            @click.native="
              taskMap.type = taskMap.type.removeFlag(
                SYNC_TYPE.ToPub,
                SYNC_TYPE.ToUnit
              )
            "
            >不同步</el-radio
          >
        </el-form-item>
        <template
          v-if="
            (schema.isUser || schema.isContainer) &&
              (taskMap.type.hasFlag(SYNC_TYPE.ToUnit) ||
                taskMap.type.hasFlag(SYNC_TYPE.ToPub))
          "
        >
          <el-form-item label="同步目标">
            <el-input v-model="taskMap.target" />
          </el-form-item>
          <el-form-item v-if="schema.isContainer" label="自身同步方式">
            <el-radio
              :label="true"
              :value="taskMap.type.hasFlag(SYNC_TYPE.Self)"
              @click.native="
                taskMap.type = taskMap.type.addFlag(SYNC_TYPE.Self)
              "
              >同步节点自身</el-radio
            >
            <el-radio
              :label="true"
              :value="!taskMap.type.hasFlag(SYNC_TYPE.Self)"
              @click.native="
                taskMap.type = taskMap.type.removeFlag(SYNC_TYPE.Self)
              "
              >节点自身不同步，仅同步子节点</el-radio
            >
          </el-form-item>
          <template v-if="taskMap.type.hasFlag(SYNC_TYPE.ToUnit)">
            <el-form-item label="登录权限(创建时)">
              <el-checkbox
                :value="taskMap.perm.hasFlag(PERM.Web)"
                @change="
                  taskMap.perm = taskMap.perm.toggleFlag(PERM.Web, $event)
                "
                >网页</el-checkbox
              >
              <el-checkbox
                :value="taskMap.perm.hasFlag(PERM.Flashmail)"
                @change="
                  taskMap.perm = taskMap.perm.toggleFlag(PERM.Flashmail, $event)
                "
                >闪电邮</el-checkbox
              >
              <el-checkbox
                :value="taskMap.perm.hasFlag(PERM.Yixin)"
                @change="
                  taskMap.perm = taskMap.perm.toggleFlag(PERM.Yixin, $event)
                "
                >易信</el-checkbox
              >
              <el-checkbox
                :value="taskMap.perm.hasFlag(PERM.Pop)"
                @change="
                  taskMap.perm = taskMap.perm.toggleFlag(PERM.Pop, $event)
                "
                >POP</el-checkbox
              >
              <el-checkbox
                :value="taskMap.perm.hasFlag(PERM.Imap)"
                @change="
                  taskMap.perm = taskMap.perm.toggleFlag(PERM.Imap, $event)
                "
                >IMAP</el-checkbox
              >
              <el-checkbox
                :value="taskMap.perm.hasFlag(PERM.Smtp)"
                @change="
                  taskMap.perm = taskMap.perm.toggleFlag(PERM.Smtp, $event)
                "
                >SMTP</el-checkbox
              >
              <el-checkbox
                :value="taskMap.perm.hasFlag(PERM.Dashi)"
                @change="
                  taskMap.perm = taskMap.perm.toggleFlag(PERM.Dashi, $event)
                "
                >邮箱大师</el-checkbox
              >
            </el-form-item>
            <el-form-item label="使用权限(创建时)">
              <el-checkbox
                :value="taskMap.perm.hasFlag(PERM.BigAttachment)"
                @change="
                  taskMap.perm = taskMap.perm.toggleFlag(
                    PERM.BigAttachment,
                    $event
                  )
                "
                >云附件</el-checkbox
              >
              <el-checkbox
                :value="taskMap.perm.hasFlag(PERM.AddrVisible)"
                @change="
                  taskMap.perm = taskMap.perm.toggleFlag(
                    PERM.AddrVisible,
                    $event
                  )
                "
                >通讯录显示</el-checkbox
              >
              <el-checkbox
                :value="taskMap.perm.hasFlag(PERM.AddrRight)"
                @change="
                  taskMap.perm = taskMap.perm.toggleFlag(PERM.AddrRight, $event)
                "
                >通讯录查看</el-checkbox
              >
              <el-checkbox
                :value="taskMap.perm.hasFlag(PERM.IsArchive)"
                @change="
                  taskMap.perm = taskMap.perm.toggleFlag(PERM.IsArchive, $event)
                "
                >塞班斯归档</el-checkbox
              >
            </el-form-item>
            <el-form-item label="重置密码(创建时)">
              <el-checkbox
                :value="taskMap.perm.hasFlag(PERM.ResetpassGeneral)"
                @change="
                  taskMap.perm = taskMap.perm.toggleFlag(
                    PERM.ResetpassGeneral,
                    $event
                  )
                "
                >允许使用将军令重置密码</el-checkbox
              >
              <el-checkbox
                :value="taskMap.perm.hasFlag(PERM.ResetpassMobile)"
                @change="
                  taskMap.perm = taskMap.perm.toggleFlag(
                    PERM.ResetpassMobile,
                    $event
                  )
                "
                >允许使用手机重置密码</el-checkbox
              >
            </el-form-item>
            <el-form-item label="收发限制(创建时)">
              <el-checkbox
                :value="taskMap.perm.hasFlag(PERM.ReceiveLimit)"
                @change="
                  taskMap.perm = taskMap.perm.toggleFlag(
                    PERM.ReceiveLimit,
                    $event
                  )
                "
                >禁止接受域外邮件</el-checkbox
              >
              <el-checkbox
                :value="taskMap.perm.hasFlag(PERM.SendLimit)"
                @change="
                  taskMap.perm = taskMap.perm.toggleFlag(PERM.SendLimit, $event)
                "
                >禁止发送域外邮件</el-checkbox
              >
            </el-form-item>
          </template>
        </template>
      </template>
      <el-form-item>
        <el-button type="primary" @click="save">保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { mapState } from "vuex";
import LDAP from "@/api/sync/ldap";
import PERM from "@/constant/perm";
import SYNC_TYPE from "@/constant/syncType";

export default {
  name: "entry-editor",
  data() {
    return {
      PERM,
      SYNC_TYPE,
      dn: this.$attrs.dn, // isAdd: 父级DN, edit: 当前DN
      isAdd: this.$attrs.isAdd,
      schemaName: this.$attrs.schemaName,
      entryName: "",
      taskMap: null,
      attrData: null,
      loaded: false
    };
  },
  computed: {
    ...mapState(["options", "schemas"]),
    schema: vm => vm.schemas?.find(s => s.name === vm.schemaName),
    editableAttrs: vm => vm.schema?.attrs.filter(a => a.editable) ?? []
  },
  async created() {
    // 等待Store初始化完成
    await this.$store.init;

    this.fetchData();
  },
  methods: {
    async fetchData() {
      let response = this.isAdd
        ? await LDAP.ENTRY_ADD_DATA({ schema: this.schemaName })
        : await LDAP.ENTRY_EDIT_DATA({ dn: this.dn });
      if (response.data.state) {
        this.schemaName = response.data.schemaName;
        this.entryName = response.data.entryName;
        this.attrData = response.data.attrData;
        this.taskMap = response.data.taskMap;
        this.loaded = true;
      }
    },
    emptyRequiredField() {
      for (let i = 0; i < this.schema.attrs.length; i++) {
        let attr = this.schema.attrs[i];
        if (attr.editable) {
          if (this.schema.attrHandlers[attr.name]) {
            for (
              let j = 0;
              j < this.schema.attrHandlers[attr.name].props;
              j++
            ) {
              let prop = this.schema.attrHandlers[attr.name].props[j];
              if (prop.required && !this.attrData[prop.name]) {
                return prop;
              }
            }
          } else {
            if (attr.required && !this.attrData[attr.name]) {
              return attr;
            }
          }
        }
      }
    },
    check() {
      if (!this.entryName) {
        this.$message.info("名称不能为空!");
        return false;
      }
      let field = this.emptyRequiredField();
      if (field) {
        this.$message.info(field.title + "不能为空!");
        return false;
      }
      return true;
    },
    async save() {
      if (this.check()) {
        let data = {
          dn: this.dn,
          schema: this.schemaName,
          entryName: this.entryName,
          attrData: this.attrData,
          taskMap: this.taskMap
        };
        let response = this.isAdd
          ? await LDAP.ENTRY_ADD(data)
          : await LDAP.ENTRY_EDIT(data);

        if (response.data.state) {
          //TODO: 更新节点树
          try {
            await this.$confirm("保存成功，是否继续编辑？", "保存成功", {
              confirmButtonText: "继续编辑",
              type: "success"
            });
            if (this.isAdd) {
              this.dn = `${this.schema.dn}=${this.unEscapeName(
                this.entryName
              )},${this.dn}`;
              this.taskMap.dn = this.dn;
              this.isAdd = false;
            }
          } catch {
            this.$emit("complete");
          }
        } else {
          let msg = response.message || "保存失败!";
          if (response.data && response.data.diagnosticMessage) {
            msg += "(" + response.data.diagnosticMessage + ")";
          }
          this.$message.error(msg);
        }
      }
    },
    syncEnable() {
      if (
        this.taskMap.type === SYNC_TYPE.Inherit ||
        this.taskMap.type === SYNC_TYPE.None
      ) {
        this.taskMap.type =
          SYNC_TYPE.Sync |
          SYNC_TYPE.Self |
          SYNC_TYPE.Children |
          SYNC_TYPE.ToUnit |
          SYNC_TYPE.WithDomainGroup;
      }
    },
    unEscapeName(str) {
      for (let es of ["\\", '"', "+", ",", ";", "<", ">", "#", "="]) {
        str = str.replace(new RegExp("\\" + es, "g"), "\\" + es);
      }
      return str;
    }
  }
};
</script>
<style lang="less" scoped>
.editor-box {
  height: 600px;
  overflow: auto;
}
.el-form-item {
  color: #606266;
  .el-select,
  .el-input {
    width: 400px;
  }
}
</style>
